<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <div class="row">
                <h5 class="card-title text-primary mx-auto">
                    {{localizationStore.translate('contract.setting')}}
                </h5>
            </div>
            <!-- company.contract.setting.update -->
            <form
            >
                <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                        <div class="form-group">
                            <div class="controls">
                                <label class="label-green" for="consultation_fee">
                                    {{localizationStore.translate('company.detail.consultation.fee')}}
                                </label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">$</span>
                                    </div>
                                    <input
                                        type="number"
                                        class="form-control"
                                        :placeholder="localizationStore.translate('company.detail.consultation.fee.placeholder')"
                                        id="consultation_fee"
                                        name="consultation_fee"
                                        data-toggle="popover"
                                        :data-content="localizationStore.translate('contract.setting.popover.message')"
                                        data-trigger="hover"
                                        :data-original-title="`<span class='feather-icon d-flex align-items-center'>${localizationStore.translate('contract.setting.popover.title')}</span>`"
                                        data-placement="top"
                                        data-html="true"
                                        v-model="consultation_fee"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mx-auto my-auto">
                        <button type="button" class="btn btn-primary mr-1" @click="saveContract">{{ localizationStore.translate('save.changes') }}</button>
                        &nbsp;&nbsp;
                        <button type="button" data-dismiss="modal" class="btn btn-outline-secondary">{{ localizationStore.translate('close') }}</button>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../../stores/LocalizationStore.js'
import axios from 'axios'
export default{
    components:{

    },
    setup(){
        const consultation_fee = ref();
        return{
            consultation_fee,
            userStore : useUserStore(),
            businessStore : useBusinessStore(),
            localizationStore : useLocalizationStore(),
        }
    },
    watch: {
        async 'businessStore.business' (value) {
            this.consultation_fee = value.settings.consultation_fee
        },
    },
    methods:{
        saveContract(){
            const data= {
                consultation_fee:this.consultation_fee,
            }
            const route = this.$router.resolve(
                {
                    name: 'company-contract-setting-update',
                }
            );
            axios.put(route.href,data).then(({data})=>{
                if(data.error == false){
                    toastr.success(data.message,'Success')
                }else{
                    toastr.success(data.message,'Error')
                }
            })
        },
        selectMode(val){
            this.mode = val
        }
    }
}
</script>
